export default __webpack_public_path__ + "img/fdb5676c96cc537cf023990e72f077a5.svg";